import "./features/robot-animation";
import { bootProductSlider } from "./home/product-slider";

bootProductSlider({
  enableFramePlayerEverywhere: true,
  replaceCablesScene: true,
});
